import styled from 'styled-components'

export const StyledValuesOptimization = styled.div`
  width: ${(p) => (p.showCheckbox ? 34 : 40)}px;
  min-width: ${(p) => (p.showCheckbox ? 34 : 40)}px;
  display: flex;
  flex-shrink: 0;
  ${(p) =>
    p.onClick &&
    `
      cursor: pointer;
     
      &:hover {
        .etb-column,
        .etb-label {
          background-color: #f1f1f1;
        }
      }
    `};
`;
